import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { FatturaForm } from '../../../form/fattura-form';
import { SezioneFattureResponse } from '../../../models/dto/sezione-fatture-response';
import { Fattura } from '../../../models/fattura';
import { SezioneFatture } from '../../../models/sezioni/sezione-fatture';
import { FormValidationService } from '../../../services/form-validation.service';

@Component({
    selector: 'div [fattura-form-edit]',
  templateUrl: '../../../form/fattura-form.html'
})

export class FattureEditComponent extends FatturaForm {
  fattura: Fattura;
  sezione: SezioneFatture;
  urlUpdate: string;
  urlReadSezioneAltreParti: string;

  @Output() onReturn: EventEmitter<SezioneFatture> = new EventEmitter<SezioneFatture>();

  constructor(@Inject(OperationsService) operationService,
              @Inject(FormBuilder) campiForm,
              @Inject(HelpersService) helpers: HelpersService,
              @Inject(FormValidationService) formValidationService: FormValidationService) {
        super(operationService, campiForm, helpers, formValidationService);
  }

  ngOnInit() {
    this.setTitle('Modifica Fattura');
    this.isInserimento(false);
  }

  getFattura() {
    return this.fattura;
  }

  getUrlReadSezioneAltreParti() {
    return this.urlReadSezioneAltreParti;
  }

  getRequest(request: Fattura) {
    this.operationService.updateFattura(this.urlUpdate, request, this.sezione.id).subscribe((response:any) => this.datiFattura(response));
  }

  datiFattura(response: SezioneFattureResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(sezione: SezioneFatture, fattura: Fattura, idSezioneAltreParti: string, urlUpdate: string, urlReadSezioneAltreParti: string) {
    this.fattura = fattura;
    this.sezione = sezione;
    this.urlUpdate = urlUpdate;
    this.urlReadSezioneAltreParti = urlReadSezioneAltreParti;
    this.readSezioneAltreParti(idSezioneAltreParti);
    this.createForm();
    this.populateSelect();
  }

}
